import React, { useState } from 'react';
import './fold.css';

const Fold9 = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is this real AI calling?",
      answer: "Yes—the agent fully engages in natural dialogue, responds to questions, and escalates when needed."
    },
    {
      question: "What about privacy?",
      answer: "All calls include AI disclosure; customers can opt out; recordings and data comply with GDPR/CCPA."
    },
    {
      question: "How do I integrate?",
      answer: "Plug‑and‑play Shopify app + a simple dashboard—no dev required."
    },
    {
      question: "What does it cost?",
      answer: "Pricing per call is $0.15–$0.39 vs. human call at ~$1/minute. Expected ROI in 3–6 months."
    },
    {
      question: "What if they don't answer?",
      answer: "Our system leaves a voicemail and follows up with SMS link + offer and also auto schedules a follow-up call."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="fold-content">
      <div className="faq-container">
        <div className="section-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Everything you need to know</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="question-text">{faq.question}</span>
                <span className={`faq-icon ${openIndex === index ? 'open' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </button>
              <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                <div className="answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fold9;